import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { findReview, questIsInRejectedState } from '../../../utils/review'
import { isInternalReviewer } from '../../../utils/user'

export default class ReviewStatusIndicator extends Component {
  render() {
    const { reviewType, currentReviews, user, quest } = this.props
    const review = findReview(currentReviews, reviewType)

    return (
      <div className={this.getCssClasses(review, user, quest)}>
        {this.props.intlReviewType}
      </div>
    )
  }

  getCssClasses(review, user, quest) {
    var cssClasses = 'review-status-indicator'
    if (!review || review.accepted === null) {
      cssClasses += ' no-review'
    } else if (
      review.accepted === true ||
      Boolean(review.approved_by) === true
    ) {
      cssClasses += ' accepted'
    } else if (review.accepted === false) {
      cssClasses += ' rejected'
    }

    if (this.props.reviewStatus === 'rejected') {
      if (!review || review.accepted === true) {
        cssClasses += ' dimmed-review-label'
      }
    }

    if (questIsInRejectedState(quest) && !isInternalReviewer(user)) {
      if (!review || review.accepted === true) {
        cssClasses += ' hidden-review-label'
      }
    }
    return cssClasses
  }
}

ReviewStatusIndicator.propTypes = {
  reviewType: PropTypes.string.isRequired,
  currentReviews: PropTypes.array,
  reviewStatus: PropTypes.string.isRequired,
  intlReviewType: PropTypes.string.isRequired,
  approvals: PropTypes.array,
  user: PropTypes.object.isRequired,
  quest: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/questbanner/ReviewStatusIndicator.js